import { Component } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import StatusMessage from '@shared/components/StatusMessage';
import { notifyAtatus } from '@/helpers/atatus';

export function withRouter(Child) {
  return (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    return <Child {...props} navigate={navigate} location={location} />;
  };
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    notifyAtatus(error, { componentStack: errorInfo?.componentStack });
    // eslint-disable-next-line no-console
    if (process.env.NODE_ENV !== 'production') {console.log(error, errorInfo);}
  }
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }
  render() {
    const {
      state: { hasError },
      props: { fallback, children },
    } = this;

    if (hasError) {
      // You can render any custom fallback UI
      return (
        fallback || (
          <StatusMessage
            title="Something went wrong."
            description="We’re looking into it. Refresh the page or go to another page."
            action={<Button themeColor="primary" onClick={() => window.location.reload()}>Refresh</Button>}
          />
        )
      );
    }

    return children;
  }
}
export default withRouter(ErrorBoundary);
